import React, { Component, PropTypes } from 'react';

const link = 'https://itunes.apple.com/us/app/sewing-translator/id1193066175?mt=8';

export default class AppStore extends Component {
    render(){
        const imgPath = `${process.env.PUBLIC_URL}/appstore/${this.props.lang}.svg`;
        return <a href={link} className="appStore"><img src={imgPath} alt=''/></a>;
    }
}

AppStore.propTypes = {
    lang: PropTypes.string.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/components/AppStore.js
 **/